'use strict';
import Axios from 'axios';
import Errors from '@/api/errors.json';
import store from '@/store';
import Moment from 'moment';
import BrowserStore from 'store';
// import { HIDDEN_SMS_COUNTRIES } from '@/_helpers/constants';

export function configureAxios(app) {
  const locale = store.state && store.state.locale ? store.state.locale.value : 'ru';
  Axios.defaults.baseURL = process.env.API_URL;
  Axios.defaults.headers.common['Content-Type'] = 'application/json';
  Axios.defaults.headers.common['Accept-Language'] = locale;
  Axios.interceptors.response.use(
    response => {
      if (
        response.data.meta !== undefined &&
        response.data.meta.status !== undefined &&
        response.data.meta.status === 'redirect' &&
        response.data.meta['redirect-url'] !== undefined
      ) {
        location.href = response.data.meta['redirect-url'];
      } else {
        return response;
      }
    },
    error => {
      if (error.response && error.response.status === 401) {
        if (app.app && app.app.$route.path !== 'login') {
          app.app.$router.push({ name: 'login' });
        }
        /* store.commit('updateRoute', {
          name: 'login'
        }) */
      } else if (error.response && error.response.status === 404) {
        if (
          (error.response.request &&
            error.response.request.responseURL &&
            error.response.request.responseURL.indexOf('/online-interviews/meeting/') !== -1) ||
          (error.response.request &&
            error.response.request.responseURL &&
            error.response.request.responseURL.indexOf('/twilio') !== -1) ||
          (error.response.request &&
            error.response.request.responseURL &&
            error.response.request.responseURL.indexOf('/company-mailer') !== -1)
        ) {
          return Promise.reject(error);
        }

        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );
}

export function parseResponse(response) {
  if (!response || !response.data || !(response.data.data instanceof Array)) {
    throw new Error('Invalid response');
  }

  return { data: response.data.data, meta: response.data.meta || {} };
}

export function parseResponseV3(response, key, params) {
  if (!response || !response.data || !response.data._embedded) {
    throw new Error('Invalid response');
  }
  return {
    data: response.data._embedded[key],
    meta:
      {
        pageNumber: response.data._page,
        totalPages: response.data._page_count,
        total: response.data._total_items,
        count: params.limit
      } || {}
  };
}

export function handleError(error, redirectToLogin = true) {
  const response = error.response;
  if (response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx

    if (response.status === 401 && redirectToLogin) {
      store.commit('updateRoute', {
        name: 'login'
      });

      return null;
    }

    if (!response.data || !response.data.meta || !response.data.meta.error) {
      return Errors['SERVER_ERROR'];
    }

    let error = response.data.meta.error;
    error.id = response.data.meta.id;
    error.status = response.status;
    // TODO: remove  in future. 404 from api must show in toaster
    // if (response.status === 404) {
    //   store.commit('updatePageStatus', 404);
    //   return error;
    // }

    if (error.message) {
      return error;
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    return window.$tr('common.error.networkError');
  } else {
    // Something happened in setting up the request that triggered an Error
    return error;
  }

  return Errors['UNKNOWN_ERROR'];
}

/**
 *
 * @param {string} dateOfBirth
 */
export function getAgeInYears(dateOfBirth) {
  const mom = new Moment(dateOfBirth);
  const now = new Moment();

  let years = now.year() - mom.year();

  if (now.dayOfYear() < mom.dayOfYear()) {
    years--;
  }

  return years;
}

export function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export function linkify(inputText) {
  const linkExp = /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i;
  const mailExp = /^mailto:/i;
  let text = inputText;
  const options = { target: '__blank' };
  if (typeof text !== 'string') {
    return null;
  }
  if (text === null || text === '') {
    return text;
  }
  let rawText = text;
  const html = [];
  const URLS = [];
  let match;
  let i;
  let url;
  // eslint-disable-next-line no-cond-assign
  while ((match = rawText.match(linkExp))) {
    [url] = match;
    if (!match[2] && !match[4]) {
      url = (match[3] ? 'http://' : 'mailto:') + url;
    }
    i = match.index;
    if (rawText.substr(0, i)) {
      html.push(rawText.substr(0, i));
    }
    html.push('<a ');
    if (options) {
      Object.keys(options).forEach(key => {
        html.push(`${key}="${options[key]}" `);
      });
    }
    html.push('href="');
    URLS.push(url.replace(/"/g, '&quot;'));
    html.push(url.replace(/"/g, '&quot;'));
    html.push('">');

    if (match[0].replace(mailExp, '')) {
      html.push(match[0].replace(mailExp, ''));
    }
    html.push('</a>');
    rawText = rawText.substring(i + match[0].length);
  }
  if (rawText) {
    html.push(rawText);
  }
  return html.join('');
}

/* eslint-disable */
// https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
// export function ArrayIncludesPolyfill() {
//   // https://tc39.github.io/ecma262/#sec-array.prototype.includes
// if (!Array.prototype.includes) {
//   Object.defineProperty(Array.prototype, 'includes', {
//     value: function(searchElement, fromIndex) {
//
//       if (this == null) {
//         throw new TypeError('"this" is null or not defined');
//       }
//
//       // 1. Let O be ? ToObject(this value).
//       var o = Object(this);
//
//       // 2. Let len be ? ToLength(? Get(O, "length")).
//       var len = o.length >>> 0;
//
//       // 3. If len is 0, return false.
//       if (len === 0) {
//         return false;
//       }
//
//       // 4. Let n be ? ToInteger(fromIndex).
//       //    (If fromIndex is undefined, this step produces the value 0.)
//       var n = fromIndex | 0;
//
//       // 5. If n ≥ 0, then
//       //  a. Let k be n.
//       // 6. Else n < 0,
//       //  a. Let k be len + n.
//       //  b. If k < 0, let k be 0.
//       var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
//
//       function sameValueZero(x, y) {
//         return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
//       }
//
//       // 7. Repeat, while k < len
//       while (k < len) {
//         // a. Let elementK be the result of ? Get(O, ! ToString(k)).
//         // b. If SameValueZero(searchElement, elementK) is true, return true.
//         if (sameValueZero(o[k], searchElement)) {
//           return true;
//         }
//         // c. Increase k by 1.
//         k++;
//       }
//
//       // 8. Return false
//       return false;
//     }
//   });
// }
// }
/* eslint-enable */

export function getUniqueName(names, name) {
  const getIdRegEx = /\s[0-9]*$/i;
  let uId = 1;
  let nameId = name.match(getIdRegEx);
  let newName = name;

  while (checkDuplicateName(names, newName)) {
    if (nameId) {
      nameId = Number(nameId[0]);
      newName = name.replace(/\s[0-9]*$/i, ` ${nameId + 1}`);
    } else {
      newName = `${name} ${uId++}`;
    }
  }

  return newName;
}

export function setComputedName(user, first_field = 'name', second_field = 'surname') {
  const surname = user[second_field] || '';

  return Object.assign({}, user, {
    computed_name: `${user[first_field]} ${surname} (${user.email})`,
    computed_name_reverse: `${surname} ${user[first_field]} (${user.email})`,
    id: user.email
  });
}

export function setFullName(user, first_field = 'name', second_field = 'surname') {
  return Object.assign({}, user, {
    full_name: user[second_field] ? `${user[first_field]} ${user[second_field]}` : user[first_field],
    full_name_reverse: user[first_field] ? `${user[second_field]} ${user[first_field]}` : user[second_field]
  });
}

export function setResponseComputedName(response) {
  const surname = response.candidate.surname || '';

  return Object.assign({}, response, {
    computed_name: `${response.candidate.name} ${surname} (${response.candidate.email})`,
    computed_name_reverse: `${surname} ${response.candidate.name} (${response.candidate.email})`
  });
}

export function transformBR(text = '') {
  return text.split('<br/>').join('\n');
}

export function transformNL(text = '') {
  return text.split('\n').join('<br/>');
}

export function compileTemplate(template, params, locale = 'ru') {
  const transformedText = transformBR(template);

  const is_japan_locale = locale === 'ja';

  let compiledTemplate = transformedText
    .replace(/{{company_name}}/gi, params.data.company.name || '')
    .replace(/{{recruiter_phone}}/gi, params.data.user.phone || '')
    .replace(/{{recruiter_position}}/gi, params.data.user.position || '')
    .replace(/{{recruiter_email}}/gi, params.data.user.email || '');

  if (params.isTypeShareLink) {
    compiledTemplate = compiledTemplate.replace(
      /{{recruiter_name}}/gi,
      !params.is_japan_locale
        ? `${params.data.user.name} ${params.data.user.surname}`
        : `${params.data.user.surname} ${params.data.user.name}`
    );
  } else {
    compiledTemplate = compiledTemplate
      .replace(/{{recruiter_name}}/gi, params.data.user.name)
      .replace(/{{recruiter_lastname}}/gi, params.data.user.surname);
  }

  if (params.isCompileVacancy) {
    compiledTemplate = compiledTemplate.replace(/{{vacancy_title}}/gi, params.data.vacancyTitle || '');
  }

  if (params.isCompileCandidate) {
    const candidate = params.data.candidateName;

    compiledTemplate = compiledTemplate.replace(
      /{{candidate_name}}/gi,
      !is_japan_locale ? `${candidate.name}` : `${candidate.surname}`
    );
  }

  return compiledTemplate;
}

function checkDuplicateName(vacanciesName, vacancyName) {
  return vacanciesName.find(item => item === vacancyName);
}

export function get_local_storage(name) {
  return BrowserStore.get(name);
}

export function delete_local_storage(name) {
  return BrowserStore.remove(name);
}

export function get_address(addressData, placeResultData) {
  let description = '';
  if (addressData.country) {
    description =
      (addressData.locality ? addressData.locality + ', ' : '') +
      (addressData.administrative_area_level_1 ? addressData.administrative_area_level_1 + ', ' : '') +
      addressData.country;
  } else {
    description = addressData.locality;
  }

  return {
    place_id: placeResultData.place_id,
    description
  };
}

export function get_digits_string(val) {
  if (!val) {
    return '';
  }

  // Возврат только цифр из входной строки, без любых других символов
  return val.match(/\d+/g) ? val.match(/\d+/g).join('') : '';
}

export function default_pluralization(choice, choicesLength, locale, pluralizationRules) {
  var defaultImpl = function (_choice, _choicesLength) {
    _choice = Math.abs(_choice);

    if (_choicesLength === 2) {
      return _choice ? (_choice > 1 ? 1 : 0) : 1;
    }

    return _choice ? Math.min(_choice, 2) : 0;
  };

  if (locale in pluralizationRules) {
    return pluralizationRules[locale].apply(this, [choice, choicesLength]);
  } else {
    return defaultImpl(choice, choicesLength);
  }
}

export function slovene_pluralization(choice, choicesLength) {
  if (choice === 0) {
    return 0;
  }

  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;

  if (!teen && endsWithOne) {
    return 0;
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 1;
  }

  return choicesLength < 4 ? 2 : 3;
}

export function thousandSeprator(amount) {
  if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  } else {
    return amount;
  }
}

export function load_script(src, id, callback, type = 'async') {
  let s, r, t;
  r = false;
  s = document.createElement('script');
  s.type = 'text/javascript';
  s.id = id || '';
  s.src = src;
  s[type] = 1;
  s.onload = s.onreadystatechange = function () {
    if (!r && (!this.readyState || this.readyState === 'complete')) {
      r = true;
      if (callback) {
        callback();
      }
    }
  };
  t = document.getElementsByTagName('script')[0];
  t.parentNode.insertBefore(s, t);
}

export function recursiveAxiosRequestAfterTimeout(config) {
  return Axios(config).catch(error => {
    if (error.code === 'ECONNABORTED') {
      return recursiveAxiosRequestAfterTimeout(config);
    }
    throw error;
  });
}

export function updateZendeskLocale() {
  if (window && window.zE && window.$tr) {
    const tr = window.$tr;
    var language = window.navigator
      ? window.navigator.language || window.navigator.systemLanguage || window.navigator.userLanguage
      : 'ru';
    language = language.substr(0, 2).toLowerCase();

    let concierge_name = tr('zendesk.chat.concierge.name', 'en');

    switch (language) {
      case 'en':
        concierge_name = tr('zendesk.chat.concierge.name', 'en');
        break;
      case 'ru':
        concierge_name = tr('zendesk.chat.concierge.name', 'ru');
        break;
      case 'ja':
        concierge_name = tr('zendesk.chat.concierge.name', 'ja');
        break;
      default:
        concierge_name = tr('zendesk.chat.concierge.name', 'en');
        break;
    }

    window.zE('webWidget', 'updateSettings', {
      webWidget: {
        chat: {
          title: {
            'en-US': tr('zendesk.chat.title', 'en'),
            ru: tr('zendesk.chat.title', 'ru'),
            ja: tr('zendesk.chat.title', 'ja'),
            '*': tr('zendesk.chat.title', 'en')
          },
          concierge: {
            name: concierge_name,
            title: {
              'en-US': tr('zendesk.chat.concierge.title', 'en'),
              ru: tr('zendesk.chat.concierge.title', 'ru'),
              ja: tr('zendesk.chat.concierge.title', 'ja'),
              '*': tr('zendesk.chat.concierge.title', 'en')
            }
          }
        },
        answerBot: {
          title: {
            'en-US': tr('zendesk.answerbot.title', 'en'),
            ru: tr('zendesk.answerbot.title', 'ru'),
            ja: tr('zendesk.answerbot.title', 'ja'),
            '*': tr('zendesk.chat.title', 'en')
          },
          avatar: {
            url: '/static/images/elements/zendesk-avatar.png'
          }
        }
      }
    });
  }
}

export function formatTimeValue(time, format = 'mm:ss') {
  if (!time) {
    return '00:00';
  }
  if (time && `${time}`.indexOf(':') !== -1) {
    return `${time}`;
  }

  const result = time ? Moment.duration(time, 'seconds').format(format, { trim: false }) : '00:00';
  return result;
}

export function cleanTimeValue(value) {
  if (!value || `${value}`.indexOf(':') === -1) {
    return value;
  }
  let time = value.split(':');

  return time.length === 3 ? +time[0] * 3600 + +time[1] * 60 + +time[2] : +time[0] * 60 + +time[1];
}

export function check_hidden_country(val) {
  return !(val && val.toUpperCase() === 'RU');
}

export function formattedPreparationTime(preparationTime) {
  return Moment.duration(preparationTime, 'seconds').format('mm:ss', { trim: false });
}

export function promiseSleep(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}

export function getSubdomain() {
  if (!window.location || !window.location.host) {
    return '';
  }

  const host = window.location.hostname;
  const hostArray = host.split('.');
  return hostArray.slice(hostArray.length - 2).join('.');
}

export function isDomainRu() {
  const host = window.location.hostname;
  const hostArray = host.split('.');
  const domain = `${hostArray.slice(hostArray.length - 1)}`;

  if (window.location.hostname.indexOf('release-ai.vcv') !== -1) {
    return false;
  } else if (window.location.hostname.indexOf('release-ru.vcv') !== -1 || window.location.hostname === 'localhost') {
    return true;
  }

  return domain === 'ru' || domain === 'team' ? true : false;
}

export function loadScript(src, callback) {
  var s, r, t;
  r = false;
  s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = src;
  s.async = true;
  t = document.getElementsByTagName('script')[0];
  t.parentNode.insertBefore(s, t);
}

export function openNewWindow(windowParams) {
  // window parameters
  const url = windowParams.url;
  const title = windowParams.title || '';
  const w = windowParams.width || 700; // window width
  const h = windowParams.height || 800; // window height

  // Fixes dual-screen position
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const frameWindow = window.open(
    url,
    title,
    `scrollbars=yes, width=${w / systemZoom}, height=${h / systemZoom}, top=${top}, left=${left}`
  );

  if (frameWindow === null || typeof frameWindow === 'undefined') {
    alert(window.$tr('need-popup-window-on'));
    return;
  }

  if (window.focus) frameWindow.focus();
}

export function stringifyPaginationV3(paginationParams) {
  let queryString = '';

  if (paginationParams._page) {
    queryString += `&page=${paginationParams._page}`;
  }
  if (paginationParams._limit) {
    queryString += `&limit=${paginationParams._limit}`;
  }

  return queryString;
}

// declOfNum(1, ['минута', 'минуты', 'минут']); // вернёт — минута
export function declOfNum(number, words) {
  return words[
    number % 100 > 4 && number % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
  ];
}

export function isNumeric(num) {
  return (typeof num === 'number' || (typeof num === 'string' && num.trim() !== '')) && !isNaN(num);
}

export function onVisibilityChange(callback) {
  var visible = true;

  if (!callback) {
    throw new Error('no callback given');
  }

  function focused() {
    if (!visible) {
      callback((visible = true));
    }
  }

  function unfocused() {
    if (visible) {
      callback((visible = false));
    }
  }

  // Standards:
  if ('hidden' in document) {
    visible = !document.hidden;
    document.addEventListener('visibilitychange', function () {
      (document.hidden ? unfocused : focused)();
    });
  }
  if ('mozHidden' in document) {
    visible = !document.mozHidden;
    document.addEventListener('mozvisibilitychange', function () {
      (document.mozHidden ? unfocused : focused)();
    });
  }
  if ('webkitHidden' in document) {
    visible = !document.webkitHidden;
    document.addEventListener('webkitvisibilitychange', function () {
      (document.webkitHidden ? unfocused : focused)();
    });
  }
  if ('msHidden' in document) {
    visible = !document.msHidden;
    document.addEventListener('msvisibilitychange', function () {
      (document.msHidden ? unfocused : focused)();
    });
  }
  // IE 9 and lower:
  if ('onfocusin' in document) {
    document.onfocusin = focused;
    document.onfocusout = unfocused;
  }
  // All others:
  window.onpageshow = window.onfocus = focused;
  window.onpagehide = window.onblur = unfocused;
}
